import React, { useState } from "react";
import InputMelli from "../inputMelli/inputMelli.component";
import InputName from "../inputName/inputName.component";
import {
  setLoginMelli,
  setLoginName,
  setReferralMobile,
  setSurvey,
} from "../../redux/login/login.actions";
import { useDispatch, useSelector } from "react-redux";
import SurveyDropDown from "../surveyDropDown/surveyDropDown.component.jsx";
import { selectUserToken } from "../../redux/user/user.selectors";
import {
  selectLoginName,
  selectLoginMelli,
  selectReferralMobile,
  selectSurvey,
} from "../../redux/login/login.selectors";
import {
  InputContainerStyled,
  InputStyled,
  SurveyStyled,
} from "./loginPhoneLastStep.styles";
import { toEnglishNum, toPersianNum } from "../../assets/utils";
const LoginPhoneLastStep = () => {
  const dispatch = useDispatch();
  const setName = (name) => {
    dispatch(setLoginName(name));
  };
  const setMelli = (melli) => {
    dispatch(setLoginMelli(melli));
  };
  const setRefMobile = (mobile) => {
    dispatch(setReferralMobile(mobile));
  };

  const tname = useSelector(selectLoginName);
  const tmelli = useSelector(selectLoginMelli);
  const trefMobile = useSelector(selectReferralMobile);
  console.log(trefMobile);
  const regex = /^[0-9\b]+$/;
  const MelliOnChange = (e) => {
    console.log(e.target.value);
    if (
      toEnglishNum(e.target.value) === "" ||
      regex.test(toEnglishNum(e.target.value))
    ) {
      setMelli(toEnglishNum(e.target.value));
    }
  };
  const RefMobileOnChange = (e) => {
    console.log(e.target.value);
    if (
      toEnglishNum(e.target.value) === "" ||
      regex.test(toEnglishNum(e.target.value))
    ) {
      setRefMobile(toEnglishNum(e.target.value));
    }
  };
  // console.log("sam", obj);
  return (
    <div>
      {/* <InputName />
      <InputMelli /> */}
      <InputContainerStyled>
        <div>نام و نام‌خانوادگی (اختیاری)</div>
        <InputStyled
          type="text"
          value={tname}
          onChange={(e) => setName(e.target.value)}
        />
      </InputContainerStyled>
      <InputContainerStyled>
        <div>کدملی (اختیاری)</div>
        <InputStyled
          type="text"
          value={toPersianNum(tmelli)}
          onChange={(e) => MelliOnChange(e)}
          maxLength={10}
        />
      </InputContainerStyled>
      <InputContainerStyled>
        <div>شماره موبایل یا کد معرف (اختیاری)</div>
        <InputStyled
          type="text"
          value={toPersianNum(trefMobile)}
          onChange={(e) => RefMobileOnChange(e)}
          maxLength={11}
        />
      </InputContainerStyled>
      <InputContainerStyled>
        <div>نحوه آشنایی با بارنت (اختیاری)</div>
        <SurveyDropDown />
      </InputContainerStyled>
    </div>
  );
};

export default LoginPhoneLastStep;
